<template>
  <section class="iframe-section">
    <div class="background-container">
      <Header :notificationIconClass="`fa-calendar-check`" :playProfileNotification="playProfileNotification" v-if="!hideHeader" />

      <iframe v-show="showFrame" class="iframeWindow" id="the_iframe" ref="the_iframe" :src="foyerSrc" frameborder="0" allow="autoplay; fullscreen; encrypted-media; camera"></iframe>
      <!-- <iframe v-show="showFrame" class="iframeWindow" id="the_iframe" ref="the_iframe" src="http://127.0.0.1:5500/minimundo.html" frameborder="0" allow="autoplay; fullscreen"></iframe> -->
    </div>
    <div class="iframe-footer-wrapper">
      <!-- <img class="foyer-instructions" :src="imageHelp" v-if="imageHelp" alt> -->
      <Footer />
    </div>
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Footer from '@/components/general/Footer.vue';
import api from '@/services/api.js';

export default {
  name: 'Iframe',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      footerKey: 0,
      showFrame: true,
      setZ: false,
      activityData: { images: {} },
      foyerSrc: '', //https://proto-assets.s3.amazonaws.com/semesp/foyer/360/index.html
      imageHelp: '', //https://proto-assets.s3.amazonaws.com/semesp/foyer/360/img/drags/drag%2B%2B.png
      authorizedRoute: '',
      authorizationData: {},
      hideHeader: true,
      playProfileNotification: false,
    };
  },

  computed: {
    mainActivity() {
      if (this.$store.state.availableActivities.length == 1) {
        return {
          name: 'Activity',
          params: {
            stream: this.$store.state.availableActivities[0].activity_id,
          },
        };
      } else {
        return {
          name: 'ActivityList',
        };
      }
    },
  },
  watch: {
    $route() {
      this.loadActivity();
    },
    '$store.state.user.language': {
      handler() {
        if (this.activityData.property?.sendToken) {
          this.foyerSrc = this.activityData.property.src + '?token=' + this.$store.state.user.token + '&user_id=' + this.$store.state.user.id + '&language-code=' + this.$store.state.user.language + '&event_id=' + this.$store.state.eventId;
        } else if (this.activityData.property?.sendLanguage) {
          this.foyerSrc = this.activityData.property.src + '?language-code=' + this.$store.state.user.language;
        }
      },
    },
  },

  methods: {
    loadActivity() {
      api
        .get(`activity/${this.$route.params.stream}`)
        .then(async (response) => {
          //console.log(response);
          let tempImages = { ...this.activityData.images };
          this.activityData = { ...this.activityData, ...response.data };
          const tempProperty = { src: '', img: '' };
          this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
          this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;
          this.foyerSrc = this.activityData.property.src;
          this.imageHelp = this.activityData.property.img;
          this.hideHeader = this.activityData.property.hideHeader ? true : false;
          if (this.$store.state.eventId == '74581de0-4c3d-11eb-8ce9-353a355b297f') {
            // console.log('EVENTO ACHE');
            this.getLevelsData();
            this.$nextTick(() => {
              this.routeUserPerLevel();
            });
          }
          if (this.$store.state.eventId == '3e5e7030-0c44-11ee-9977-33234f3e6416') {
            const cpf = await this.getUserCPF();
            this.foyerSrc = this.foyerSrc + '?user_id=' + this.$store.state.user.id + '&cpf=' + cpf;
            console.log('EVENTO UNICO QUIZ', this.foyerSrc);
          }
          if (this.activityData.property?.sendToken) {
            this.foyerSrc = this.foyerSrc + '?token=' + this.$store.state.user.token + '&user_id=' + this.$store.state.user.id + '&language-code=' + this.$store.state.user.language;
          } else if (this.activityData.property?.sendLanguage) {
            this.foyerSrc = this.foyerSrc + '?language-code=' + this.$store.state.user.language;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    getUserCPF() {
      return new Promise((resolve, reject) => {
        api
          .get(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`)
          .then((response) => {
            resolve(response.data.cpf);
          })
          .catch((err) => {
            console.error(err);
            reject(err);
          });
      });
    },
    getLevelsData() {
      if (this.$store.state.eventId == '74581de0-4c3d-11eb-8ce9-353a355b297f') {
        // console.log('getLevelsData - EVENTO ACHE');
        api
          .get(`activity/13c4fd90-6268-11eb-9bb9-e183bd803493`)
          .then((response) => {
            //console.log(response);
            this.authorizationData = { ...response.data };
            const tempProperty = { src: '', img: '' };
            this.authorizationData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
            let levels = this.authorizationData.property.levels ? this.authorizationData.property.levels : [];
            try {
              levels.map((level) => {
                // console.log('getLevelsData - user level: ' + this.$store.state.user.role);
                level.level.map((role) => {
                  if (this.$store.state.user.role == role) {
                    // console.log('getLevelsData - estou em: ' + level.name);
                    this.authorizedRoute = level.name;
                    // console.log('getLevelsData -AUTHORIZED ROUTE: ' + level.name);
                  }
                });
              });
            } catch {
              (err) => {
                console.error(err);
              };
            }
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    routeUserPerLevel() {
      let levels = this.activityData.property.levels;
      levels.map((level) => {
        // console.log('user level: ' + this.$store.state.user.role);
        level.level.map((role) => {
          if (this.$store.state.user.role == role) {
            // console.log('estou em: ' + level.name);
            this.foyerSrc = level.src;
          }
        });
      });
      if (this.foyerSrc == '') {
        setTimeout(() => {
          this.$router.back();
          alert(`Sinto muito, você não tem acesso à essa área. Tente ${this.authorizedRoute != '' ? this.authorizedRoute : 'outro link.'}`);
        }, 700);
      }
    },
    messagesHandler(e) {
      try {
        // console.log('message received: ', e);
        if (e.data === 'toggle_full_screen') {
          this.toggleFullScreen();
        } else if (e.data.interactions) {
          const interactions = e.data.interactions;
          console.log('message received: ', { interactions });
          api.post(`sessionAction/`, {
            action: 'Interactions Action',
            properties: JSON.stringify({ interactions: interactions.data }),
            userid: this.$store.state.user.id,
            sessionid: this.$store.state.user.token,
            event_id: this.$store.state.eventId,
          });
          if (interactions.goHome) {
            this.$router.push({ name: 'Home' }).catch((err) => {
              console.error('navigation error', err);
            });
          }
        } else if (e.data.name) {
          this.$router.push(e.data);
        } else {
          let received = JSON.parse(e.data);
          // console.log('message received: ', { received });

          if (received.url) {
            window.open(received.url);
          } else if (received.startDate) {
            // console.log('message received startDate: ', { received });
            this.apiPostSchedule(received);
          } else {
            if (received.name) {
              this.$router.push(received).catch((err) => {
                console.error('navigation error', err);
              });
            }
            api.post(`sessionAction/`, {
              action: 'Foyer Action',
              properties: JSON.stringify({ router: this.$route, foyer: e.data }),
              userid: this.$store.state.user.id,
              sessionid: this.$store.state.user.token,
              event_id: this.$store.state.eventId,
            });
          }
        }
      } catch (e) {}
    },
    apiPostSchedule(item) {
      // console.log('apiPostSchedule item', { item });

      this.playProfileNotification = false;
      let payload = {
        event_id: this.$store.state.eventId,
        user_id: this.$store.state.user.id,
        activity_id: item.activity_id,
        start_date: new Date(item.startDate),
        finish_date: new Date(item.finishDate),
        title: item.title,
        description: item.description,
        notes: '',
        config: JSON.stringify({ group: item.group, image: item.image, class: 'default', draggable: true }),
        links: item.target ? item.target : '',
        guests: JSON.stringify([]),
        organizer: this.$store.state.user.id,
        status: 'Confirmado',
        confirm: JSON.stringify(false),
        public: JSON.stringify(false),
      };
      // console.log('payload:', { payload });
      api
        .get(`event/${this.$store.state.eventId}/schedule`)
        .then((response) => {
          // console.log('apiGetCart response', { response });
          let isNew =
            response.data.filter(
              (schedule) =>
                schedule.links == payload.links &&
                schedule.activity_id == payload.activity_id &&
                schedule.title == payload.title &&
                schedule.description == payload.description &&
                new Date(schedule.start_date).toLocaleTimeString('pt-BR') == new Date(payload.start_date).toLocaleTimeString('pt-BR') &&
                new Date(schedule.finish_date).toLocaleTimeString('pt-BR') == new Date(payload.finish_date).toLocaleTimeString('pt-BR'),
            ).length == 0;

          // console.log(
          //   'isNew?',
          //   isNew,
          //   response.data.filter(
          //     (schedule) => schedule.activity_id == payload.activity_id && schedule.title == payload.title && schedule.description == payload.description && new Date(schedule.start_date).toLocaleTimeString('pt-BR') == new Date(payload.start_date).toLocaleTimeString('pt-BR') && new Date(schedule.finish_date).toLocaleTimeString('pt-BR') == new Date(payload.finish_date).toLocaleTimeString('pt-BR'),
          //   ).length == 0,
          // );

          if (isNew) {
            // console.log('NEW !!!!', isNew);
            api
              .post(`event/${this.$store.state.eventId}/schedule/`, payload)
              .then((response) => {
                // console.log('apiPostSchedule:', { response });
                this.playProfileNotification = true;
                setTimeout(() => {
                  // alert('Compromisso incluído');
                  this.playProfileNotification = false;
                }, 3000);
              })
              .catch((err) => {
                this.playProfileNotification = false;
                console.error(err);
              });
          } else return;
        })
        .catch((err) => console.error(err));
    },
    toggleFullScreen() {
      const iframeRef = this.$refs.the_iframe;
      if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (iframeRef.requestFullScreen) {
          iframeRef.requestFullScreen();
        } else if (iframeRef.mozRequestFullScreen) {
          iframeRef.mozRequestFullScreen();
        } else if (iframeRef.webkitRequestFullScreen) {
          iframeRef.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
  },
  beforeMount() {
    this.loadActivity();
  },
  mounted() {
    window.addEventListener('message', this.messagesHandler, false);
    this.$nextTick(() => {
      this.footerKey++;
      setTimeout(() => {
        this.$refs.the_iframe.focus(); // focus to propagate arrow keys to the iframe
      }, 1000);
    });
  },
  beforeDestroy() {
    window.removeEventListener('message', this.messagesHandler);
  },
};
</script>

<style lang="scss">
.fullscreen-button {
  position: absolute;
  top: 200px;
  right: 0;
  z-index: 1;
  background: transparent;
  border: none;
  color: white;
  font-size: 1.5rem;
  padding: 0.5rem;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.5);
  }
}
.iframe-section {
  background-position: center;
  background-size: cover;
  background-repeat: repeat-y;
}
.background-container {
  // background-color: white;
  min-height: calc(100dvh - 30px);
}

.video-iframe {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10%;
  height: 100%;
  width: 100%;
  outline: none;
}

.iframeWindow {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100vw;
  // z-index: 1;
  background: var(--main-color);
  background-position: right 0% top 100px;
  background-repeat: no-repeat;
  background-size: cover;
  // animation: iframeFadeIn 0.9s ease-in;
}

@keyframes iframeFadeIn {
  0% {
    filter: blur(10px);
  }
  100% {
    filter: none;
  }
}

.zindex {
  z-index: 2;
}

.iframe-footer-wrapper {
  position: fixed;
  bottom: 0px;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.foyer-instructions {
  width: 180px;
  height: 100%;
  margin-bottom: 4px;
  user-select: none;
  @include media('<=phone') {
    display: none;
  }
}
</style>
